// extracted by mini-css-extract-plugin
export default {"container":"InfoModal_container__1Hut+","modal":"InfoModal_modal__gkoXG","button":"InfoModal_button__ugx5R"};